/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/web-app-bff-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { CreateFragmentCreationMutationRequest, CreateFragmentCreationMutationResponse } from "../models/CreateFragmentCreation";

export function getCreateFragmentCreationUrl() {
  const res = { method: 'POST', url: `/fragments` as const }
  return res
}

/**
 * @summary Create a fragment
 * {@link /fragments}
 */
export async function createFragmentCreation(data: CreateFragmentCreationMutationRequest, config: Partial<RequestConfig<CreateFragmentCreationMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<CreateFragmentCreationMutationResponse, ResponseErrorConfig<Error>, CreateFragmentCreationMutationRequest>({ method : "POST", url : getCreateFragmentCreationUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}